import axios from 'axios'
import { API_BASE_URL } from '../config'
/**
 * Retrieves authentication details (token, user ID, app type) from localStorage.
 *
 * @returns {{ token: string, loggedInUserId: string, appType: string }}
 *   An object containing:
 *     - token: API token for Authorization header.
 *     - loggedInUserId: ID of the currently logged-in user.
 *     - appType: Current application type (e.g., 'client' or 'team').
 */
export const getAuthDetails = () => {
	const local = JSON.parse(localStorage.getItem('usersStore'))
	const appType = JSON.parse(localStorage.getItem('appType'))
	return {
		token: local?.apiToken || '',
		loggedInUserId: local?.loggedInUserId || '',
		appType: appType || ''
	}
}

/**
 * axiosInstance is a preconfigured Axios HTTP client.
 *
 * - baseURL: Set to the API_BASE_URL from config.
 * - withCredentials: Includes cookies/credentials on cross-site requests.
 * - request interceptor:
 *     • Adds 'Authorization' header if token exists.
 *     • Appends 'controller_id' and 'app_type' query params based on auth details.
 *
 * @type {import('axios').AxiosInstance}
 */
const axiosInstance = axios.create({
	baseURL: API_BASE_URL,
	withCredentials: true // Ensure credentials are included in requests
})

axiosInstance.interceptors.request.use(
	(config) => {
		const { token, loggedInUserId, appType } = getAuthDetails()
		if (token) {
			config.headers['Authorization'] = token
		}
		if (loggedInUserId) {
			const params = new URLSearchParams(config.params || {})
			params.append('controller_id', loggedInUserId)
			params.append('app_type', appType)
			config.params = params
		}
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

export default axiosInstance
